// Allows making a selector in class style - element can have multiple hooks on it.
// If we have these elements
// 1. <div data-hook="one">
// 2. <div data-hook="two one">
// 3. <div data-hook="twoone">
// dataHook('one') will select 1st and 2nd
// dataHook(['one', 'two']) will select 2nd
//
// More about '~=' selector here: https://developer.mozilla.org/en-US/docs/Web/CSS/Attribute_selectors
export function dataHook(...hooks: (string[] | string)[]) {
  return hooks
    .map(hook => {
      if (Array.isArray(hook)) {
        return hook.map(h => `[data-hook~="${h}"]`).join('');
      }
      if (hook === '') {
        // If we want to select empty value we need to use strict equality
        return `[data-hook="${hook}"]`;
      }
      return `[data-hook~="${hook}"]`;
    })
    .join(' ');
}
